<style scoped>
    * {
        font-family: PingFangSC-Semibold, PingFang SC;
    }

    .agree {
        height: 40%;
        margin: 0.1rem 0rem;
        background: #FFFFFF;
        padding: 0.15rem;
        border-radius: 0.1rem;
        overflow-y: scroll;
    }

    .agree .tip{
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2F2F2F;
    }

    .agree .title {
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        text-align: center;
        margin-bottom: 0.1rem;
    }

    .agree .text {
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 0.2rem;
    }

</style>
<template>
    <div style="background: #ffffff;">
        <div class="agree">
            <div class="tip">
                <span style="color: #F86E33;">特别提醒：</span>
                平台将根据您的综合资质为您匹配机构：{{name}}，请阅读并同意以下协议，并注意接听机构的审核电话
            </div>
            <div style="background: #FBFBFB;padding: 0.1rem;margin-top: 0.1rem;">
                <div class="title">个人信息授权协议</div>
                <div class="text">
                    <div>本协议是由杭州焱虎网络科技有限公司(以下简称“我们”)与用户(以下简称“您”)就个人信息共享转让所订立。</div>
                    <div>
                        一、您同意本协议以数据电文形式订立。如您通过网络页面点击“同意”或“注册”或“申请”或“接受用户授权协议”(以网页显示为准)，即视为您已阅读理解本协议的全部内容并同意我们出于相关页面所述目的，将您的个人信息提供给为您提供【账号注册、授信审核、贷款等】服务的其他个人信息处理者（以下简称“第三方”）。
                    </div>
                    <div>二、当您通过本页面使用第三方产品或服务时，您的个人信息将由本公司共享转让给该第三方。如果您不同意本协议的任意内容，或者无法准确理解本协议任何条款的含义，请不要进行授权及后续操作。</div>
                    <div>三、本协议中共享转让的个人信息含个人敏感信息及其他个人信息、数据，包括但不限于：</div>
                    <table border="1" cellpadding="0" cellspacing="8" style="margin: 10px 0px;">
                        <tr style="font-size: 14px;font-weight: bolder;">
                            <td>共享、转让内容</td>
                            <td>共享、转让对象</td>
                            <td>实现方式</td>
                            <td>目的</td>
                        </tr>
                        <tr>
                            <td>姓、性别、手机号、所在地区、申请金额及其他（月收入范围、社保是否缴纳、公积金是否缴纳、是否有房、是否有车、保单是否缴纳、申请时间、是否有信用卡）</td>
                            <td>{{name}}</td>
                            <td><span v-if="type == 0">API机构</span><span v-else>APP机构</span></td>
                            <td>贷款产品推荐</td>
                        </tr>
                    </table>
                    <div>
                        四、您同意并授权我们将您的上述信息共享转让给第三方，但我们与第三方在开展上述信息共享前，会严格要求第三方对在信息共享中所获取的您的上述信息予以保密并且依照相关法律法规或者本协议的约定使用您的上述信息。
                    </div>
                    <div>
                        五、您理解，第三方服务由相应的第三方就以上服务在处理您个人信息的过程中，对您个人信息的安全性独立承担责任。请您在点击授权同意前，仔细阅读并理解第三方的服务协议与隐私政策。因该第三方不当处理您的个人信息产生的纠纷，或第三方服务违反相关法律法规或者协议的约定，或您在使用第三方服务过程中遭受了损失，请您与第三方协商解决。
                    </div>
                    <div>六、您同意，凡因本协议引起的任何您与我们之间的有关争议、纠纷，首先通过友好协商的方式解决，如协商不能达成一致的，任何一方均可向本平台所在地有管辖权的人民法院提起诉讼。</div>
                    <div>七、本协议未尽事宜参照《平台服务协议》与《隐私保护政策》执行。</div>
                </div>
            </div>
        </div>

        <Loading :isShow="loading"></Loading>
    </div>
</template>
<script>
    import Loading from '@/components/loading';

    export default {
        components: {
            Loading
        },
        data() {
            return {
                loading:false,
                agencyCityId:0,
                name:"",
                type:0,
            };
        },
        created() {
            this.util.title("个人信息授权协议");
            var agencyCityId = this.$route.query.agencyCityId;
            if (agencyCityId) {
                this.agencyCityId = agencyCityId;
            }
            this.getAgencyInfo();
        },
        methods: {
            getAgencyInfo() {
                this.loading=true;
                this.$get("/app/api/v1/order/agency/getAgencyByCityId?agencyCityId=" + this.agencyCityId).then((res) => {
                    if (res.code == 200) {
                        this.loading=false;
                        var data = res.data;
                        this.name = data.name;
                        this.type = data.type;
                    }else{
                        this.loading=false;
                    }
                });
            },

        },
    };
</script>
